<div class="box-view">
    <h1>ขั้นตอนการใช้ Library </h1>
    <p>รองรับ Angular Version 12-16</p>
    <h5>1. ติดตั้ง Library </h5>
    <div class="exp" [innerHTML]="install"></div>
    <br><br>
    <h5>2. เพิ่ม NgAvestaTranslateModule ใน app.module.ts </h5>
    <div class="exp" [innerHTML]="module"></div>
    <br><br>
    <h5>3. Login </h5>
    <div class="exp" [innerHTML]="app"></div>
    <br><br>
    <h5>4. วิธีใช้ </h5>
    <div class="exp" [innerHTML]="useapp"></div>
    <br><br>


    <h1>หรือ</h1>
    <br>
    <h1>ขั้นตอนการเรียกใช้ API</h1>
    <p> GET : https://restapi.legitid.org/translate</p>
    <p>ส่วนของ Headers ให้ใส่</p>
    <p>Keyuser : [ KEY User ]</p>
    <p>KeyApi : [ KEY API ]</p>
    <iframe src="https://restapi.legitid.org/translate/swagger/index.html#/" frameborder="0" width="100%"></iframe>
</div>